// Perfis "restritos": enxergam apenas um conjunto fechado de módulos, caem num
// landing próprio (NÃO têm Home) e são barrados em qualquer outra rota — inclusive
// nas páginas soltas abertas a qualquer logado (aniversariantes, colaboradores,
// indicadores, manual de ajuda) e em URLs digitadas na mão.
//
// Fonte ÚNICA da regra: App.js (portão de rota), Login.js (destino pós-login) e
// Sidebar.js (itens de menu) consomem daqui — não replicar a regra em cada arquivo.
//
// ⚠️ Casamento por perfil é EXATO (a chave do mapa é a string do PERFIL na
//    dtbUsuariosSite). O recorte por loja NÃO mora aqui — é do backend
//    (escopoLojaSql, que chaveia pela loja do usuário, não pelo perfil).
//
// Coordenador de Qualidade: dentro do Financeiro, o Estorno de Venda, o Controle
// de GPRS (16/09/2026), o Petty Cash e o Registro de Nulos (os dois em
// 17/09/2026); a Atualização de Cadastro (dentro do RH); o módulo Chamados
// (31/08/2026); e a Biblioteca (04/09/2026). Nos quatro do Financeiro e no
// Chamados ele é equiparado ao Gerente da própria loja; e o módulo Marketing
// (18/09/2026).
// Preso à própria loja em todos, menos a Biblioteca e o Marketing, que são da
// rede inteira, sem recorte.
//
// Presidencia: SÓ o módulo Projetos (Inventário Executivo). Criado em 2026-08-04
// para o Sr. Marco (ID 44), que era `Diretoria` — perfil de 8 pessoas.
// ⚠️ NÃO é preferência de interface, é REDUÇÃO DE ALCANCE: a sessão dele dura
//    1 ano (ver server.js › login) para não precisar relogar no atalho do
//    celular, e a única proteção que sobra é o desbloqueio do aparelho. Numa
//    conta `Diretoria`, essa sessão longa entregaria Auditoria, Contábil,
//    Fiscal, Financeiro, Compras, Manutenção e os painéis da Home. Aqui entrega
//    o inventário e nada mais.
// ⚠️ A trava de verdade é o BACKEND, e ela sai de graça: `Presidencia` não está
//    em nenhuma lista de `authorizeRoles`, então toda rota protegida o nega.
//    Este arquivo só evita que ele veja menu e telas que não pode usar.
//
// TI: SÓ o módulo Chamados (02/09/2026, pedido da Julia). O técnico de TI
// trabalha o dia inteiro dentro da fila de chamados e não tem o que fazer na
// Home — entrar no portal já cai em `/chamados`.
// ⚠️ NÃO é redução de alcance nem decisão de segurança (ao contrário da
//    `Presidencia`): o menu dele já era Home + Chamados, e o backend já negava
//    o resto. O que sai de fato são a Home e as três páginas soltas abertas a
//    qualquer logado — /aniversariantes, /colaboradores e /indicadores.
// ⚠️⚠️ `Gerente TI` ficou de FORA de propósito. Ele tria e acompanha, mas
//    continua sendo gente de escritório com Home — só o `TI` (quem executa)
//    entra aqui. Não incluir por analogia de nome.
export const PERFIS_RESTRITOS = {
    'Coordenador de Qualidade': {
        landing: '/financeiro',
        // ⚠️⚠️ `/chamados` ENTROU EM 31/08/2026 (pedido da Julia): dentro do
        //    Chamados ele foi equiparado ao Gerente — abre para a própria loja,
        //    consulta a fila e VALIDA o serviço encerrado.
        //    ⚠️ Sem esta linha o portão de rota do `App.js` o manda de volta ao
        //    landing, e o botão de validar viraria uma tela que ele não alcança —
        //    sintoma que não parece permissão, porque não dá erro nenhum.
        //    ⚠️ A outra metade da regra está no backend (`PERFIS_QUE_VALIDAM` do
        //    `chamados-validacao.js` e `PERFIS_ABERTURA` do `server-chamados.js`)
        //    e na `PERMISSIONS` do `Chamados.js`. Abrir só aqui daria menu sem
        //    conteúdo; abrir só lá daria conteúdo sem caminho.
        //    ⚠️ `/biblioteca` ENTROU EM 04/09/2026, com o módulo (que nasceu
        //    `/manuais` e foi renomeado no mesmo dia, ao ganhar a Videoteca).
        //    É só LEITURA de documentação — não tem dado de loja nem
        //    ato a praticar —, mas sem esta linha o portão do `App.js` o devolve
        //    ao landing mesmo constando no `allowedRoles` da rota. É a pegadinha
        //    dos perfis restritos: a rota abre e o portão fecha, sem erro.
        //    ⚠️ `/marketing` ENTROU EM 18/09/2026, com a abertura do módulo
        //    (Gerador de Arte de Contratação + Aniversariantes do Mês). Mesma
        //    pegadinha da `/biblioteca` acima: sem esta linha o portão do
        //    `App.js` o devolve ao landing MESMO constando no `allowedRoles` da
        //    rota e no menu — a rota abre e o portão fecha, sem erro nenhum.
        //    ⚠️ Aqui ele NÃO é preso à loja: o módulo é da rede inteira.
        permite: ['/financeiro', '/rh', '/chamados', '/biblioteca', '/marketing'],
    },
    'Presidencia': {
        landing: '/projetos',
        permite: ['/projetos'],
        // Interface enxuta: sem sino, sem agenda (ver `interfaceMinima`).
        enxuto: true,
    },
    // ⚠️ Casamento EXATO pela chave: 'TI' aqui é o perfil de duas letras (quem
    //    EXECUTA o chamado), nunca um pedaço de 'Gerente TI' — a busca é por
    //    igualdade no mapa, não por substring.
    'TI': {
        landing: '/chamados',
        permite: ['/chamados'],
        // ⚠️ SEM `enxuto`: ele usa o portal todo dia, com sessão de 8h, e
        //    continua recebendo aviso no sino e enxergando a Agenda.
    },
};

// Config do perfil restrito, ou null se o perfil vê o portal normalmente.
export function getConfigRestrito(perfil) {
    return PERFIS_RESTRITOS[perfil] || null;
}

/**
 * A casca do portal (sino de avisos, botão da Agenda) sai da tela deste perfil?
 *
 * Quem vem ler um documento e ir embora não navega: o sino abre uma lista
 * sempre vazia (avisos são mirados por perfil, e este não é alvo de nenhum) e o
 * botão da Agenda dispara a vinculação com o Microsoft 365 — fluxo de
 * autorização que essa pessoa não pediu e não vai entender. Não é enfeite a
 * menos: é armadilha a menos. Hoje só a `Presidencia`.
 *
 * ⚠️⚠️ ISTO ERA DERIVADO (`permite.length === 1`) E DEIXOU DE SER EM 02/09/2026,
 *    quando o `TI` entrou com uma rota só. A contagem de rotas responde "tem
 *    para onde navegar?", que NÃO é a mesma pergunta — o `TI` fica o dia todo
 *    numa tela só e mesmo assim precisa do sino e da agenda: é gente do
 *    escritório, com sessão de 8h. Quem herdava a interface enxuta por acidente
 *    perdia aviso da empresa sem ninguém decidir isso.
 *    Agora é DECLARADO no mapa (`enxuto: true`) — e declarar é o ponto: some
 *    junto a confirmação do "Sair" do `ModuloHeader`, pensada para a sessão de
 *    1 ano no atalho do celular.
 */
export function interfaceMinima(perfil) {
    return !!PERFIS_RESTRITOS[perfil]?.enxuto;
}

// Rota inicial pós-login: o landing do perfil restrito, ou a Home para os demais.
export function getLandingPerfil(perfil) {
    return PERFIS_RESTRITOS[perfil]?.landing || '/home';
}

// O perfil pode acessar esta rota? Perfil não-restrito => sempre true (quem filtra
// é o allowedRoles de cada rota). Perfil restrito => só o que está no `permite`
// (casamento por prefixo, para pegar /financeiro?tab=estorno etc.).
export function rotaPermitida(perfil, pathname) {
    const cfg = PERFIS_RESTRITOS[perfil];
    if (!cfg) return true;
    return cfg.permite.some((base) => pathname === base || pathname.startsWith(base + '/') || pathname.startsWith(base + '?'));
}
